import React from "react";
import styled from "styled-components";
import { NavLink } from "react-router-dom";
import { useMediaQuery } from "../../hooks/useMediaQuery";

const MenuItemSpan = styled.span`
    display: block;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-left: 1rem;
    color: #000000;
    text-decoration: none;
    background: #fff;
    font-size: 0.9rem;
    transition: color 100ms linear;
    border-color: black;
    border-top: solid;
    border-bottom: solid;
    border-width: thin;
    
    &:hover{
      background:#01BAF0;
      color: #fff;
    }
`

const DropdownMenuItem = ({ title, link, onClick,style }) => {

  let isMobile = useMediaQuery('(min-width: 992px)')
  return (
    <li>
      {isMobile ?
        <NavLink to={link} activeClassName="myActiveLink" style={{ textDecoration: 'none' }}>
          <div>
            <MenuItemSpan style={style}>{title}</MenuItemSpan>
          </div>
        </NavLink>
        :
        <NavLink to={link} activeClassName="myActiveLink" onClick={onClick} style={{ textDecoration: 'none' }}>
          <div>
            <MenuItemSpan style={style}>{title}</MenuItemSpan>
          </div>
        </NavLink>
      }

    </li>
  )
};

export default DropdownMenuItem;
